const SET_RECENT_UPLOAD_INFO = 'videoLectures/SET_RECENT_UPLOAD_INFO';
const REMOVE_VIDEO_LECTURE = 'videoLectures/REMOVE_VIDEO_LECTURE';
const CLEAR_VIDEO_LECTURES = 'videoLectures/CLEAR_VIDEO_LECTURES';
const SET_VIDEO_LECTURE = 'videoLectures/SET_VIDEO_LECTURE';

export default {
  SET_RECENT_UPLOAD_INFO,
  REMOVE_VIDEO_LECTURE,
  CLEAR_VIDEO_LECTURES,
  SET_VIDEO_LECTURE,
};



// WEBPACK FOOTER //
// ./src/app/video-lectures/store/mutation-types.js